import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';
import { MultiOption, MultiSelect } from './MultiSelect';

function SelectLocationComponent() {
  const { t } = useTranslation('moniterByRecruiters');

  const { locations, positionFilters, isLocationsfetching } = useStoreState(
    /* istanbul ignore next */ (state) => state.moniterByRecruiters,
  );
  const { fetchLocations, setPositionFilter } = useStoreActions(/* istanbul ignore next */ (state) => state.moniterByRecruiters);

  useEffect(() => {
    fetchLocations().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Map locations to generic options
  const locationOptions: MultiOption<string>[] = React.useMemo(
    () =>
      locations.map((loc) => ({
        value: loc.id,
        label: loc.name,
      })),
    [locations],
  );

  return (
    <MultiSelect
      options={locationOptions}
      selectedValues={positionFilters.businessIds ?? []}
      onChange={(vals, selectAll) => {
        setPositionFilter({ key: 'businessIds', value: vals });
        setPositionFilter({ key: 'isAllLocationsSelected', value: selectAll });
      }}
      selectAll={positionFilters.isAllLocationsSelected}
      label={t('filter.location.label')}
      allSelectText={t('filter.location.all')}
      placeholder={t('filter.location.search')}
      isLoading={isLocationsfetching}
      height={400}
      itemHeight={30}
    />
  );
}

export const SelectLocation = React.memo(SelectLocationComponent);
